import React, { Component } from "react";
import "./../../../assests/styles/CreditLines.css";

export default class CreditLine extends Component {
	constructor(props) {
		super(props);
		this.state = {
			status: [],
			productName: [],
			selectedStatus: null,
			selectedProduct: null,
			from_dpd: null,
			to_dpd: null,
			equals: null,
			bzid: null
		};
		this.getStatusList = this.getStatusList.bind(this);
		this.getProductName = this.getProductName.bind(this);
		this.handleSearchLocal = this.handleSearchLocal.bind(this);
		this.setFromDPD = this.setFromDPD.bind(this);
		this.setToDPD = this.setToDPD.bind(this);
		this.setEquals = this.setEquals.bind(this);
		this.setBZID = this.setBZID.bind(this);
		this.handleClear = this.handleClear.bind(this);
		this.hitApiOnEnter = this.hitApiOnEnter.bind(this);
		this.clearFromDpd = this.clearFromDpd.bind(this);
		this.clearToDpd = this.clearToDpd.bind(this);
		this.clearEquals = this.clearEquals.bind(this);
		this.clearBzId = this.clearBzId.bind(this);
	}

	componentDidMount() {
		this.hitApiOnEnter();
		var searchedBzid = JSON.parse(localStorage.getItem("searched_bzid"));
		if(searchedBzid){
			this.setState({
				bzid: searchedBzid
			})
		}
	}

	hitApiOnEnter() {
		var input = document.getElementById("myInput");
		input.addEventListener("keyup", function (event) {
			event.preventDefault();
			if (event.keyCode === 13) {
				document.getElementById("myBtn").click();
			}
		});
	}

	handleSearchLocal() {
		this.props.handleSearch(this.state.selectedStatus, this.state.selectedProduct, this.state.from_dpd, this.state.to_dpd, this.state.equals, this.state.bzid, 0);
	}

	handleClear() {
		var emptyString = "";
		this.setState({
			selectedStatus: emptyString,
			selectedProduct: emptyString,
			from_dpd: emptyString,
			to_dpd: emptyString,
			equals: emptyString,
			bzid: emptyString
		});
	}

	clearFromDpd() {
		var emptyString = "";
		this.setState({
			from_dpd: emptyString
		})
	}

	clearToDpd() {
		var emptyString = "";
		this.setState({
			to_dpd: emptyString
		})
	}

	clearEquals() {
		var emptyString = "";
		this.setState({
			equals: emptyString
		})
	}

	clearBzId() {
		var emptyString = "";
		this.setState({
			bzid: emptyString
		})
	}

	render() {
		return (
			<div className="creditLinesContainer">
				<div className="topActionBarStyle" id="myInput">
					{this.topActionBar()}
				</div>
			</div>
		);
	}

	topActionBar() {
		return (
			<div className="topActionBarStyle" style={{ padding: "15px 15px 15px 30px" }}>
				<div className="row">
					<div className="col-md-9">
						<div className="row">
							<div className="col-md-3 top-filter nopadding">
								<div className="row">
									<div className="col-md-9" style={{ paddingRight: "0px" }}>
										<input id={"credit_line_input"} type="text" placeholder="Search By BZID" value={this.state.bzid} onChange={this.setBZID} className="filter-text form-control" />
									</div>
									<div className="col-md-2 no-padding">
										<i className="far fa-times-circle inline" onClick={this.clearBzId} />
									</div>
								</div>
							</div>
							<div className="col-md-1 top-filter nopadding">{this.statusSelector()}</div>
							<div className="col-md-2 top-filter nopadding">{this.productTyepSelector()}</div>
							<div className="col-md-2 top-filter nopadding">
								<div className="row">
									<div className="col-md-9" style={{ paddingRight: "0px" }}>
										<input type="text" placeholder="From (DPD)" value={this.state.from_dpd} onChange={this.setFromDPD} className="filter-text form-control" />
									</div>
									<div className="col-md-2 no-padding">
										<i className="far fa-times-circle inline" onClick={this.clearFromDpd} />
									</div>
								</div>
							</div>
							<div className="col-md-2 top-filter nopadding">
								<div className="row">
									<div className="col-md-9" style={{ paddingRight: "0px" }}>
										<input type="text" placeholder="To (DPD)" value={this.state.to_dpd} onChange={this.setToDPD} className="filter-text form-control" />
									</div>
									<div className="col-md-2 no-padding">
										<i className="far fa-times-circle inline" onClick={this.clearToDpd} />
									</div>
								</div>
							</div>
							<div className="col-md-2 top-filter nopadding">
								<div className="row">
									<div className="col-md-9" style={{ paddingRight: "0px" }}>
										<input type="text" placeholder="Equals" value={this.state.equals} onChange={this.setEquals} className="filter-text form-control" />
									</div>
									<div className="col-md-2 no-padding">
										<i className="far fa-times-circle inline" onClick={this.clearEquals} />
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-1" style={{ lineHeight: "40px" }}>
						<button id="myBtn" className="btn btn-jt-green" onClick={this.handleSearchLocal}>
							Search
						</button>
					</div>
					<div className="col-md-2" style={{ lineHeight: "40px" }}>
						<button className="btn btn-default" style={{ color: "red" }} onClick={this.handleClear.bind(this)}>
							Clear Filters
						</button>
					</div>
				</div>
			</div>
		);
	}

	setFromDPD(e) {
		this.setState({
			from_dpd: e.target.value
		});
	}

	setToDPD(e) {
		this.setState({
			to_dpd: e.target.value
		});
	}

	setBZID(e) {
		this.setState({
			bzid: e.target.value
		});
		localStorage.setItem("searched_bzid",JSON.stringify(e.target.value));
	}

	setEquals(e) {
		this.setState({
			equals: e.target.value
		});
	}

	getProductName() {
		if (this.props.creditProducts) {
			return this.props.creditProducts.map((st, index) => {
				return <option key={index}>{st}</option>;
			});
		}
	}

	productTyepSelector() {
		return (
			<div>
				<select id="productType" onChange={this._productTypePicker.bind(this)} className="selectpicker" value={this.state.selectedProduct}>
					<option>Product Name</option>
					{this.getProductName()}
				</select>
			</div>
		);
	}

	getStatusList() {
		if (this.props.creditLineStatusSet) {
			return this.props.creditLineStatusSet.map((st, index) => {
				return <option key={index}>{st}</option>;
			});
		}
	}

	statusSelector() {
		return (
			<div>
				<select id="status" onChange={this._statusPicker.bind(this)} className="selectpicker" value={this.state.selectedStatus}>
					<option> Status </option>
					{this.getStatusList()}
				</select>
			</div>
		);
	}
	_statusPicker(event) {
		this.setState({
			selectedStatus: event.target.value
		});
	}
	_productTypePicker(event) {
		this.setState({
			selectedProduct: event.target.value
		});
	}
}






// WEBPACK FOOTER //
// ./src/screens/creditLines/components/creditLinesHeader.js